import service from './service';
import serviceTwo from './serviceTwo';

export const friendList = async () => {
  const response = await service.get(`/user/friends`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const toggleLocationShare = async (payload) => {
  const response = await service.post(`/user/friend/toggle-share-location`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const removeFriend = async (payload) => {
  const response = await service.post(`/invitations/remove-friend`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const sendInvitationsList = async (page, pageSize) => {
  const response = await serviceTwo.getTwo(
    `/invitations/list-friend-invites?page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const businessUserList = async (payload) => {
  const response = await serviceTwo.postTwo(`/groups/get-business-user-list`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
